<template>
  <div class="grid-badges-row">
    <span
      v-for="item in dataArray"
      :key="item.id"
      class="grid-badge"
      :class="colorClass"
    >
      {{ item[displayExpr] }}
    </span>
  </div>
</template>
<script>
import { ref } from "vue";

export default {
  name: "GridBadge",
  props: {
    data: Array,
    displayExpr: String,
    colorClass: String,
  },
  setup(props) {
    const dataArray = ref(props.data);

    return {
      dataArray,
    };
  },
};
</script>
